import { LoadableBackground } from '@confluence/loadable';

export const Pendo = LoadableBackground({
	loader: async () => (await import(/* webpackChunkName: "loadable-Pendo" */ './Pendo')).Pendo,
});

export { sendPendoTrackEvent } from './services';
